<section class="grid grid-cols-1 gap-8 lg:grid-cols-[385px_1fr]">
  <app-image-card
    [image]="project.logo"
    [title]="project.title"
    [description]="project.description"
    sectionClassName="bg-gray-100"
    imageContainerClassName="min-h-[250px] flex justify-center items-center"
    titleClassName="text-xl font-medium"
    descriptionClassName="text-tertiary-foreground text-base"/>

  <div class="flex flex-col gap-6 overflow-hidden">
    <div class="flex flex-col">
      <div class="flex h-full flex-col gap-3 rounded-3xl bg-gray-100 p-6 lg:items-start">
        <span class="text-2xl font-medium">{{ project.overview.title }}</span>
        <div class="flex flex-wrap gap-1">
          @for (badge of project.overview.badges; track badge) {
            <span class="rounded-3xl border border-gray-200 bg-background px-2 py-1 text-xs">{{ badge }}</span>
          }
        </div>
      </div>

      <div class="flex h-full flex-col gap-3 rounded-3xl bg-gray-100 p-6 font-medium lg:items-start">
        <span class="text-xl">{{ project.overview.name.title }}</span>
        <span class="text-base font-normal text-tertiary-foreground">{{ project.overview.name.description }}</span>
      </div>

      <div class="flex h-full rounded-3xl bg-gray-100 p-6 lg:items-start">
        <div class="flex flex-col gap-2">
          <span class="text-xl">{{ project.overview.shortDescription.title }}</span>
          <span
            class="text-base font-normal text-tertiary-foreground">{{ project.overview.shortDescription.description }}</span>
        </div>
      </div>

      <div class="flex h-full flex-col gap-4 rounded-3xl bg-gray-100 p-6 font-medium lg:items-start">
        <span class="text-2xl">{{ project.overview.challenge.title }}</span>
        <span class="text-xl"> {{ project.overview.challenge.highlight }}</span>
        <span class="text-base font-normal text-tertiary-foreground">{{ project.overview.challenge.description }}</span>
      </div>
    </div>

    <app-info-card
      [title]="project.solution.title"
      [highlightTitle]="project.solution.highlight"
      [description]="project.solution.description"
      sectionClassName="bg-gray-100"
      titleClassName="text-2xl font-medium"
      highlightTitleClassName="text-xl font-medium"
      descriptionClassName="text-tertiary-foreground text-base"/>

    <app-info-card
      [title]="project.outcome.title"
      [highlightTitle]="project.outcome.highlight"
      [description]="project.outcome.description"
      sectionClassName="bg-gray-100"
      titleClassName="text-2xl font-medium"
      highlightTitleClassName="text-xl font-medium"
      descriptionClassName="text-tertiary-foreground text-base"/>

    <div class="flex flex-col">
      <div class="flex h-full flex-col gap-4 rounded-3xl bg-gray-100 p-6 font-medium lg:items-start">
        <span class="text-2xl">{{ project.gallery.title }}</span>
      </div>
      <div class="flex flex-col items-center rounded-3xl bg-gray-100 p-6">
        <app-custom-carousel [images]="project.gallery.images"/>
      </div>
    </div>

    <app-info-card [title]="project.developers.title" sectionClassName="bg-gray-100"
                   titleClassName="text-2xl font-medium"/>

    <div class="hide-scrollbar w-full max-w-full cursor-grab overflow-x-auto" #scrollContainer>
      <div class="flex flex-nowrap gap-4">
        @for (employee of filteredEmployees(); track employee) {
          <app-image-card
            [image]="employee.image"
            [title]="employee.fullName"
            [subtitle]="employee.positionName"
            [headerBadges]="employee.topBadges.slice(0, 2)"
            [footerBadges]="employee.bottomBadges.slice(0, 2)"
            [showHeaderButtonBottom]="true"
            (headerButtonClick)="goToEmployee(employee)"
            buttonText="View Profile"
            btnVariant="contrast"
            buttonIcon="arrow-up-right"
            containerClassName="max-w-[344px] select-none"
            sectionClassName="bg-gray-100"
            titleClassName="text-2xl font-semibold"
            subtitleClassName="text-xl"
            imageContainerClassName="-mb-6 pt-4"/>
        }
      </div>
    </div>
  </div>
</section>
